import { Component, ComponentRef, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatDrawer } from '@angular/material/sidenav';
import { Sort } from '@angular/material/sort';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Element, ElementsService, RouteElementService, RouterOutletEvent, ProjectService } from 'dbweb-core';
import { ClipboardService } from 'ngx-clipboard';
import { take } from 'rxjs/operators';
import { IRouterState } from '../router-state';
import { LabelDrawerComponent } from './label-drawer/label-drawer.component';
import { IRecordViewProcess, IRenderRow, SelectType, TableColumnType } from './model/model';
import { BackFaceService } from './service/backface';
import { ServiceData } from './service/data';
import { ServiceService, RefreshDataConfig } from './service/service.service';
import { TableComponent } from './table/table.component';
import { ViewDrawerComponent } from './view-drawer/view-drawer.component';
import { Subscription } from 'rxjs';
import { CTRL_RECORDVIEW } from '../const';

@Component({
	selector: 'common-recview',
	templateUrl: './record-view.component.html',
	styleUrls: ['./record-view.component.scss'],
	providers: [ServiceService, BackFaceService, ServiceData]
})
export class RecordViewComponent implements OnInit, RouterOutletEvent, OnDestroy {
	@Input() eleName: string;
	@Input() title: string;
	@Input() condition: string;
	@ViewChild('dataTable', { static: true })
	dataTable: TableComponent;
	@ViewChild('labelDrawer', { static: false })
	labelDrawer: LabelDrawerComponent;
	@ViewChild('columnsDrawer', { static: false })
	columnsDrawer: ViewDrawerComponent;
	// å½åçå·¥ä½åç´ 
	element: Element;
	// æ ç­¾çæ½å±
	@ViewChild('drawer', { static: true })
	drawer: MatDrawer;
	readonly SelectTypeSelected = SelectType.Selected;
	readonly SelectTypeUnselected = SelectType.Unselected;
	showConditionalTemplateRunner = false;
	editLabelModel = false;
	private subscribe: Subscription[] = [];
	constructor(
		public svr: ServiceService,
		public ele: RouteElementService,
		private prj: ProjectService,
		public _clipboardService: ClipboardService,
		iconRegistry: MatIconRegistry,
		sanitizer: DomSanitizer,
		private router: Router,
		private eles: ElementsService
	) {
		const icons = [
			'all_chosen',
			'cancel_chosen',
			'return_chosen',
			'single_chosen',
			'double_down',
			'drag_indicator',
			'arrow_collapse',
			'arrow_expand',
			'sorting_arrows',
			'color_add',
			'file_copy',
			'bg_bottom_out',
			'default'
		];
		icons.forEach(v => {
			iconRegistry.addSvgIcon(
				v,
				sanitizer.bypassSecurityTrustResourceUrl('assets/record-view/icon/' + v + '.svg')
			);
		});
	}
	ngOnDestroy() {
		this.subscribe.forEach(v => v.unsubscribe());
	}
	onDetach(): void {
		this.dataTable.onDetach();
	}
	onAttach(ref: ComponentRef<any>, activatedRoute: ActivatedRoute): void {
		this.dataTable.onAttach(ref, activatedRoute);
	}

	ngOnInit() {
		this.subscribe.push(
			this.svr.refreshDataEvent.subscribe((v: RefreshDataConfig) => {
				this.dataTable.setDataSource(
					this.svr.data.tableData.Rows,
					this.svr.data.tableData.DisplayColumns.map(vv => ({ ...vv } as TableColumnType)),
					(v && v.keepDivide) || (v && v.keepRowCount)
				);
			})
		);
		// å¦ææ¯ç»ä»¶æ¹å¼è°ç¨
		if (this.eleName !== undefined) {
			this.svr.initByCondition(this.eles.get(this.eleName), this.title, this.condition);
		} else {
			// init param
			this.ele.currentElement.pipe(take(1)).subscribe(v => {
				this.svr.init(v.element, this.prj.frontToApiURL(v.url));
			});
		}
	}
	selectedRowText() {
		const total = this.svr.data.tableRowSelection.selected.length;
		let current = 0;
		if (this.svr.data.tableData && this.svr.data.tableData.Rows) {
			current = this.svr.data.tableData.Rows.filter(row => this.svr.data.tableRowSelection.isSelected(row.Key))
				.length;
		}
		if (total === current) {
			return `å·²é${total}æ¡`;
		} else {
			return `${current}/${total}`;
		}
	}
	onTableSort(sortInfo: Sort) {
		switch (sortInfo.direction) {
			case '':
				this.svr.data.fetchParam.Order = null;
				break;
			case 'asc':
				this.svr.data.fetchParam.Order = [sortInfo.active];
				break;
			case 'desc':
				this.svr.data.fetchParam.Order = [`-${sortInfo.active}`];
		}

		this.svr.refreshData({ keepRowCount: true }).subscribe();
	}
	searchClick() {
		this.showConditionalTemplateRunner = false;
		this.svr.refreshData().subscribe();
	}

	onRecordProcessClick(event: { pro: IRecordViewProcess; row: IRenderRow }) {
		let fields = this.svr.data.uniqueFields;
		if (event.pro.TransPath && event.pro.TransPath.length > 0) {
			fields = event.pro.TransPath;
		}
		const keyValues = fields.map(v => `[${event.row.Data[v]}]`).join(' ');
		const ustr = this.eles.frontElementURL(
			this.svr.data.rowProcesses.find(v => v.Name === event.pro.Name).ElementName,
			event.row.Processes[event.pro.Name].URL
		);
		this.router.navigateByUrl(ustr, {
			state: {
				// å ä¸ºrouteèªå¨ä¼è¿è¡encodeï¼æä»¥éè¦ææå¡ç«¯çurlè§£å¼ï¼ä½æ¯æå¡ç«¯åä¸è½ä¸ç¼ç ï¼å ä¸ºææ éè¦æ­£ç¡®å¤ç
				url: this.router.parseUrl(ustr),
				key: ustr,
				title: `${event.pro.Name} - ${keyValues}`
			} as IRouterState
		});
	}
	onToolbarProcessClick(pro: IRecordViewProcess) {
		const ustr = this.eles.frontElementURL(pro.ElementName, this.svr.data.tableData.Processes[pro.Name].URL);
		this.router.navigateByUrl(ustr, {
			state: {
				url: this.router.parseUrl(ustr),
				key: ustr,
				title: pro.Name
			} as IRouterState
		});
	}
	onNextPageClick(event: MouseEvent) {
		this.svr.data.fetchParam.Divide = this.svr.data.tableData.DownDivide;
		this.svr.data.fetchParam.DivideRowNum = this.svr.data.tableData.DownRowNum;
		if (this.svr.data.prevFetchDivide) {
			this.svr.data.upDivide = this.svr.data.upDivide || [];
			this.svr.data.upRowNum = this.svr.data.upRowNum || [];
			this.svr.data.upDivide.push(this.svr.data.prevFetchDivide);
			this.svr.data.upRowNum.push(this.svr.data.prevFetchRowNum);
		}
		this.svr.refreshData({ keepDivide: true, keepRowCount: true }).subscribe();
	}
	onPrevPageClick(event: MouseEvent) {
		if (this.svr.data.upDivide) {
			this.svr.data.fetchParam.Divide = this.svr.data.upDivide.pop();
		} else {
			this.svr.data.fetchParam.Divide = undefined;
		}
		if (this.svr.data.upRowNum) {
			this.svr.data.fetchParam.DivideRowNum = this.svr.data.upRowNum.pop();
		} else {
			this.svr.data.fetchParam.DivideRowNum = undefined;
		}
		this.svr.refreshData({ keepDivide: true, keepRowCount: true }).subscribe();
	}
	onFooterRowCountClick(event: MouseEvent) {
		this.svr.refreshRowCount().subscribe();
	}
	startRowNo() {
		if (this.svr.data && this.svr.data.tableData && this.svr.data.tableData.Rows.length > 0) {
			return this.svr.data.tableData.Rows[0].RowNum + 1;
		}
		return 0;
	}
	openLabelDrawer() {
		this.svr.data.showLabelDrawer = true;
		setTimeout(() => {
			// å¤å¶,å ä¸ºå¯¹è¯æ¡åé¨ä¼æ¹åå¼
			this.labelDrawer.selectedLabels = [...this.svr.data.selectedLabels];
			// ç¹å»æ¨¡æ¿æå¼æ½å±
			this.drawer.toggle();
		}, 0);
	}
	openColumnsDrawer() {
		this.svr.data.showLabelDrawer = false;
		if (!this.svr.data.viewList || this.svr.data.viewList.length === 0) {
			this.svr.editView.add();
		} else {
			this.svr.editView.titleInput = false;
			this.svr.editView.current = this.svr.data.viewList[0];
		}
		// ç¹å»æ¨¡æ¿æå¼æ½å±
		this.drawer.toggle();
	}
	hasConditionalTemplate() {
		return !!this.svr.data.conditionalTemplates.find(v => v.enable);
	}
	closeDrawer() {
		// this.labelDrawer.editModel = false;
		this.editLabelModel = false;
		console.log('close', this.editLabelModel, this.labelDrawer.editModel);
	}
}
